import * as React from 'react';
import { MemberContext } from '@contexts/member/MemberContext';

export const useMemberContext = () => React.useContext(MemberContext);
